document.addEventListener("click", async function (event) {
  const link = event.target.closest("[data-ga-select-item]");

  if (!link || !window.Shopify?.analytics?.publish) {
    return;
  }

  const item = {
    item_id: link.dataset.itemId || "",
    item_name: link.dataset.itemName || "",
    item_variant: link.dataset.itemVariant || "",
    price: Number(link.dataset.itemPrice || 0),
    quantity: 1
  };

  const itemIndex = Number(link.dataset.itemIndex);

  if (Number.isFinite(itemIndex) && itemIndex > 0) {
    item.index = itemIndex;
  }

  const eventData = {
    item_list_id: link.dataset.itemListId || "",
    item_list_name: link.dataset.itemListName || "",
    items: [item]
  };

  /*
   * Do not interfere with new-tab, download or modified clicks.
   */
  const isNormalSameTabClick =
    event.button === 0 &&
    !event.ctrlKey &&
    !event.metaKey &&
    !event.shiftKey &&
    !event.altKey &&
    !link.hasAttribute("download") &&
    link.target !== "_blank";

  if (!isNormalSameTabClick) {
    Shopify.analytics.publish(
      "spuds_select_item",
      eventData
    );

    return;
  }

  event.preventDefault();

  if (link.dataset.gaNavigationPending === "true") {
    return;
  }

  link.dataset.gaNavigationPending = "true";

  try {
    await Shopify.analytics.publish(
      "spuds_select_item",
      eventData
    );
  } catch (error) {
    console.warn(
      "select_item: Unable to publish Shopify event"
    );
  }

  /*
   * Give the Custom Pixel time to dispatch the GA4 request.
   */
  window.setTimeout(function () {
    window.location.assign(link.href);
  }, 250);
});